import { render, staticRenderFns } from "./BoardListAlbumLayout.vue?vue&type=template&id=1761304b&scoped=true&"
import script from "./BoardListAlbumLayout.vue?vue&type=script&lang=js&"
export * from "./BoardListAlbumLayout.vue?vue&type=script&lang=js&"
import style0 from "./BoardListAlbumLayout.vue?vue&type=style&index=0&id=1761304b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1761304b",
  null
  
)

export default component.exports